import {
  BriefcaseIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentCheckIcon,
  ExclamationTriangleIcon,
  FolderIcon,
  MapIcon,
} from "@heroicons/react/24/outline";

export const statCardStyles = [
  {
    accent: "border-slate-900 bg-slate-950 text-white",
    iconWrap: "bg-white/10 text-white",
    eyebrow: "text-slate-300",
    subtitle: "text-slate-400",
    number: "text-white",
    arrow: "text-slate-300",
  },
  {
    accent: "border-slate-200 bg-white text-slate-950",
    iconWrap: "bg-sky-100 text-sky-700",
    eyebrow: "text-slate-500",
    subtitle: "text-slate-500",
    number: "text-slate-950",
    arrow: "text-slate-500",
  },
  {
    accent: "border-slate-200 bg-white text-slate-950",
    iconWrap: "bg-emerald-100 text-emerald-700",
    eyebrow: "text-slate-500",
    subtitle: "text-slate-500",
    number: "text-slate-950",
    arrow: "text-slate-500",
  },
  {
    accent: "border-slate-200 bg-white text-slate-950",
    iconWrap: "bg-amber-100 text-amber-700",
    eyebrow: "text-slate-500",
    subtitle: "text-slate-500",
    number: "text-slate-950",
    arrow: "text-slate-500",
  },
];

export function nameToIcon(name) {
  switch (name) {
    case "REPORTS_NOT_FINISHED":
    case "REPORTS_FINISHED":
    case "REPORTS_NOT_APPROVED":
    case "REPORTS_AGREEMENT_NOT_CONFIRMED":
      return ClipboardDocumentCheckIcon;
    case "CASES_OPEN":
      return ChatBubbleLeftRightIcon;
    case "DEVIATIONS_OPEN_TOTAL":
    case "DEVIATIONS_OPEN_ASSIGNED":
      return ExclamationTriangleIcon;
    case "PROJECTS_OPEN":
      return FolderIcon;
    case "TRIPS_DISTANCE_TOTAL_CURRENT_MONTH":
    case "TRIPS_DISTANCE_USER_TOTAL_CURRENT_MONTH":
      return MapIcon;
    default:
      return BriefcaseIcon;
  }
}

export function translateNameToTitle(name, t) {
  switch (name) {
    case "REPORTS_NOT_FINISHED":
    case "REPORTS_FINISHED":
      return t("dashboard.stats.reports");
    case "REPORTS_AGREEMENT_NOT_CONFIRMED":
      return t("dashboard.stats.report_agreements");
    case "REPORTS_NOT_APPROVED":
      return t("dashboard.stats.reports");
    case "CASES_OPEN":
      return t("dashboard.stats.cases");
    case "DEVIATIONS_OPEN_TOTAL":
    case "DEVIATIONS_OPEN_ASSIGNED":
      return t("dashboard.stats.deviations");
    case "PROJECTS_OPEN":
      return t("dashboard.stats.projects");
    case "TRIPS_DISTANCE_TOTAL_CURRENT_MONTH":
    case "TRIPS_DISTANCE_USER_TOTAL_CURRENT_MONTH":
      return t("dashboard.stats.kilometers");
    default:
      return name;
  }
}

export function translateNameToSubtitle(name, t) {
  switch (name) {
    case "REPORTS_NOT_FINISHED":
      return t("dashboard.stats.reports_not_finished");
    case "REPORTS_FINISHED":
      return t("dashboard.stats.reports_finished");
    case "REPORTS_AGREEMENT_NOT_CONFIRMED":
      return t("dashboard.stats.reports_agreement_not_confirmed");
    case "REPORTS_NOT_APPROVED":
      return t("dashboard.stats.reports_not_approved");
    case "CASES_OPEN":
      return t("dashboard.stats.cases_open");
    case "DEVIATIONS_OPEN_TOTAL":
      return t("dashboard.stats.deviations_open");
    case "DEVIATIONS_OPEN_ASSIGNED":
      return t("dashboard.stats.deviations_assigned");
    case "PROJECTS_OPEN":
      return t("dashboard.stats.projects_open");
    case "TRIPS_DISTANCE_TOTAL_CURRENT_MONTH":
    case "TRIPS_DISTANCE_USER_TOTAL_CURRENT_MONTH":
      return t("dashboard.stats.this_month");
    default:
      return name;
  }
}

export function nameToPath(name) {
  switch (name) {
    case "REPORTS_NOT_FINISHED":
      return "/dashboard/service/?tab=2";
    case "REPORTS_FINISHED":
      return "/dashboard/service/reports?filters=view:FINISHED&page=1&per_page=50&sort=asc&sortBy=created_at&view=all";
    case "REPORTS_AGREEMENT_NOT_CONFIRMED":
      return "/dashboard/service/?user=1&date=2024-12-07&page=1&per_page=20&sort=asc&sortBy=time&view=all&tab=1";
    case "REPORTS_NOT_APPROVED": {
      const filtersParam = encodeURIComponent(
        JSON.stringify([{ name: "view", value: JSON.stringify(["NOT_APPROVED"]) }])
      );
      return `/dashboard/service/reports?filters=${filtersParam}&page=1&per_page=50&sort=asc&sortBy=created_at&view=all`;
    }
    case "CASES_OPEN":
      return "/dashboard/cases";
    case "DEVIATIONS_OPEN_TOTAL":
    case "DEVIATIONS_OPEN_ASSIGNED":
      return "/dashboard/hse-ks/deviations";
    case "PROJECTS_OPEN":
      return "/dashboard/projects";
    case "TRIPS_DISTANCE_TOTAL_CURRENT_MONTH":
      return "/dashboard/trips";
    case "TRIPS_DISTANCE_USER_TOTAL_CURRENT_MONTH":
    default:
      return "/dashboard";
  }
}
